export default __webpack_public_path__ + "locales/lo-LA/DowngradePlanDialog.json?hash=09f3aedb61e2393b001eacfe6b5ee81c";